export default {
  engagement: 'ฤกษ์รับหมั้น',
  betrothal: 'ฤกษ์แห่ขั้นหมาก',
  preparing_bed: 'ฤกษ์จัดเตียงนอน',
  sewing_gown: 'ฤกษ์ตัดชุดวิวา',
  hair_combing: 'ฤกษ์เสริมสวย',
  arrival: 'ฤกษ์มงคลสมรสเข้าบ้านเจ้าบ่าว',
  car_purchasing: 'ฤกษ์ออกรถ',
  cesarean: 'ฤกษ์วันคลอด',
  starting_construction: 'ฤกษ์ก่อสร้าง',
  setting_up_shrine: 'ฤกษ์ตั้งศาล',
  ground_breaking: 'ฤกษ์มงคลเสาเอกปลูกสร้าง',
  contract_signing: 'ฤกษ์เซ็นสัญญา',
  business_opening: 'ฤกษ์เปิดธุรกิจใหม่',
  entering_house: 'ฤกษ์ทำพิธีเข้าบ้านใหม่',
  worshiping_lord: 'ฤกษ์ทำพิธีไหว้เจ้าที่',
  surgery: 'ฤกษ์ผ่าตัดทั่วไป',
  treatment: 'ฤกษ์รักษาโรค',
  cosmetic_surgery: 'ฤกษ์ศัลยกรรมความงาม',
  exam: 'ฤกษ์สอบ',
  new_wallet: 'ฤกษ์เปิดกระเป๋าสตางค์',
  gift_icsi: 'Gift & ICSI',
  marriage_registration: 'ฤกษ์จดทะเบียน',
  beauty: 'ฤกษ์เสริมความงาม',
  new_pet: 'ฤกษ์รับสัตว์เลี้ยง',
  study_abroad: 'ฤกษ์เดินทางเรียนต่อต่างประเทศ',
  product_launch: 'ฤกษ์เปิดตัวสินค้า',
}
